// extracted by mini-css-extract-plugin
module.exports = {"lessonDescriptionContainer":"styles_lessonDescriptionContainer__Txf_n","seeMoreLessButton":"styles_seeMoreLessButton__1CA0m"};